import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, OWNER } from '../data/apps';
import ThemePicker from './ThemePicker';
import { LifeBuoy, Mail } from './Icons';
import '../App.css';

function Header() {
    const [stuck, setStuck] = useState(false);

    useEffect(() => {
        const onScroll = () => setStuck(window.scrollY > 8);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header className="header" data-stuck={stuck}>
            <div className="wrap">
                <Link to="/" className="brand">
                    <span className="brand-mark">
                        <LifeBuoy />
                    </span>
                    <span className="brand-text">
                        <small>{OWNER}</small>
                        <strong>App Support</strong>
                    </span>
                </Link>

                <div className="header-actions">
                    <ThemePicker />
                    <a className="btn btn-primary" href={`mailto:${CONTACT_EMAIL}`}>
                        <Mail />
                        <span>Contact</span>
                    </a>
                </div>
            </div>
        </header>
    );
}

function Footer() {
    return (
        <footer className="footer">
            <div className="wrap">
                <p>
                    © {new Date().getFullYear()} {OWNER}. All rights reserved.
                </p>
                <nav aria-label="Footer">
                    <Link to="/">All apps</Link>
                    <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                </nav>
            </div>
        </footer>
    );
}

/**
 * Page shell: ambient background, sticky header, footer.
 * Every route renders inside this.
 */
export default function Layout({ children }) {
    return (
        <>
            <div className="aurora" aria-hidden="true">
                {/*
                 * A fixed pool of ambient shapes. Most themes style the <span>
                 * itself (blob, bubble, orb); Voxel builds real 3D solids out
                 * of the six <i> faces, which stay hidden everywhere else.
                 */}
                {Array.from({ length: 7 }, (_, i) => (
                    <span key={i}>
                        <i />
                        <i />
                        <i />
                        <i />
                        <i />
                        <i />
                    </span>
                ))}
            </div>
            <div className="grain" aria-hidden="true" />

            <div className="shell">
                <a className="skip" href="#main">
                    Skip to content
                </a>
                <Header />
                <main id="main">
                    <div className="wrap">{children}</div>
                </main>
                <Footer />
            </div>
        </>
    );
}
